import { defineMessages } from 'react-intl';

export const messages: {
	ownerName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ownerName: {
		id: 'search-page.relay.compass.owner-name',
		defaultMessage: 'Owned by {ownerName}',
		description: 'Indicates which team owns this component.',
	},
});
